import { Skeleton, useMediaQuery, useTheme } from '@mui/material';
import DynamicDropDown from '@components/DynamicDropDown';
import { useAppSelector } from '../../store';
import useUserTerminals from '@hooks/useUserTerminals';
import useRouteMatch from '@hooks/useRouteMatch';
import { Terminal } from '@api/Trinium/types';
import { useNavigate } from 'react-router';

export default function TerminalDropdown() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const selectedTerminal = useAppSelector((state) => state.applicationState.selectedTerminal);
	const { isLoading, terminals, terminalsByName } = useUserTerminals();
	const inputWidth = isMobile ? '82px' : '200px';
	const justifyContent = terminals.length === 1 ? 'right' : 'left';

	const { replaceTerminalInRoute } = useRouteMatch();
	const navigate = useNavigate();

	// When we switch terminals, change the url param and let the terminal proxy handle the state
	const terminalChange = (terminal: Terminal) => {
		const newRoute = replaceTerminalInRoute(terminal.number);
		void navigate(newRoute);
	};

	// When the user is not assigned any terminals we cannot render the dropdown
	if (terminals.length === 0) {
		return <></>;
	}

	// This really should never happen as the sites are loaded before this component but good practice.
	if (isLoading) {
		return (
			<Skeleton
				variant='rectangular'
				width={inputWidth}
				height={40}
			/>
		);
	}

	return (
		<DynamicDropDown
			options={isMobile ? terminals : terminalsByName}
			optionKey={isMobile ? 'number' : 'name'}
			renderOptionKey={(option) => (isMobile ? option.number : option.name)}
			defaultValue={selectedTerminal ?? null}
			width={inputWidth}
			onChange={terminalChange}
			textAlign={justifyContent}
			emptyText='Select a Terminal'
		/>
	);
}
